import fetch from '../fetch';

const path = process.env.VUE_APP_BASE_SERVER_URL_APP;

export const getUploadImgToken = req =>
  fetch({
    url: path + '/common/getQNToken',
    ...req,
  });
export const getDelImgToken = req =>
  fetch({
    url: path + '/common/deleteFiles',
    ...req,
  });
